import firstArticle from './firstArticle';
import secondArticle from './secondArticle';
import landing from './landing';
import header from './header';

export default {
  en: {
    translations: {
      challengeLabel: 'Challenge',
      savingResultsLabel: '(Saving Results)',
      challengeSaveHint: 'To save your results, turn on Challenge.',
      challengeSaveHelp: 'Results include only complete batches of 100 hands for each position and set of filters.',
      challengeSaveHelpStop: 'Click Stop to finish. An incomplete batch is not included in results; completed batches stay saved.',
      stopLabel: 'Stop',
      savingResultsStatus: 'Saving results…',
      resultsSaveError: 'Results could not be saved. Please try Stop again.',
      retrySaveLabel: 'Retry save',
      resultsFaqLabel: 'Results FAQ',
      averageLastMonthLabel: 'Average last month',
      guideTitle1: 'I. Starting screen',
      guideText1_1: 'Game Selection',
      guideText1_2: 'Limit selection.',
      guideText1_Low: 'GG Low rake pl 50 - 200 (5%, 2bb)',
      guideText1_Mid: 'GG High rake pl 500 - 2000 (5%, 1.5bb)',
      guideText1_High: 'Low - rake pl 50 on Poker Stars (5%, 4bb)',
      guideText1_MTT: 'Med - rake pl 200 on Poker Stars (5%, 1.375bb)',
      guideText1_MTT_PLUS: 'Med+ - rake pl 500 on Poker Stars (5%, 0.6bb)',
      guideText1_MTT_225: 'High - rake pl 5000 on Poker Stars (4.5%, 0.06bb)',
      guideText1_HU: 'MTT POT - Tournament situation by Chip EV. NO rake. Pot bet all preflop options.',
      guideText1_HU1: 'MTT 2.25 — Tournament situation by Chip EV. NO rake. 2,25bb openraise.',
      guideText1_HU2: 'MTT ANTE POT Tournament situation by Chip EV. NO rake. Pot bet all preflop options. Ante 0.8',
      guideText1_HU3: 'MTT ANTE 2.5 Tournament situation by Chip EV. NO rake. 2,5bb openraise. Ante 0.8',
      guideText1_HU4: 'HU - rake (5%, 1bb)',
      guideText1_Buckets: 'Buckets: 30,30,30',
      guideText1_Pll: 'Perfect, Large, Large',
      guideText1_In: 'I/N from 50 ',
      guideText1_3: 'Startting stack selection.',
      guideText1_cash_game: 'PS (6max):',
      guideText1_mtt: 'GG (6max):',
      guideText1_mtt_225: 'MTT POT:',
      guideText1_hu: 'MTT 2.25:',
      guideText1_hu1: 'MTT ANTE POT:',
      guideText1_hu2: 'MTT ANTE 2.5:',
      guideText1_hu3: 'HU:',
      guideText1_4: 'Navigation of steps and possibility to go back a step.',
      guideText1_5: 'Opens another Plo Preflop to compare.',
      guideText1_6: 'Our position.',
      guideText1_7: 'Our position.',
      guideText1_8: 'Multiway situations.',
      guideText1_9: 'Situations when we limp (only in situation SB vs BB), fold or Raise first in.',
      guideText1_9_BB_situation: 'BB - situation when everyone folded before SB, then SB limped and now we have to choose whether we check or raise on BB.',
      guideText1_10: 'Situations when somebody raised before us and we have to decide – fold, call or raise.',
      guideText1_11: 'Easy RFI - When turned on, hands are removed from the bottom of the opening (EV below 0.05 on the effectiveness of the action). This feature will be very useful for beginners, as it will remove problematic hands from the opening.',
      guideText1_12: 'Smart range - cell gets colored depending on the percentage of folds in this type of hand.',
      guideText1_13: 'On hover, the percentage of actions for each position is displayed.',

      guideTitle2: 'II. Screen of starting positions.',
      guideText2_1: 'Display of the selected position.',
      guideText2_2: 'Choosing the two highest cards in hand if the hand does not contain a pair.',
      guideText2_3: 'The presence of 2 to 3 cards of the same suit in the starting hand.',
      guideText2_4: 'Having two cards of the same suit and two more (double-suited hands) in the starting hand.',
      guideText2_5: 'If your starting hand has at least one pair. Blue - if the hand is suited. Red - if the hand is double-suited.',
      guideText2_6: 'Hands that are initially folded in this position.',
      guideText2_7: 'Impossible starting hands.',

      guideTitle3: 'III. Starting double-suited hand screen.',
      guideText3_1: 'The red color of the hand indicates two-suit.',
      guideText3_2: 'Impossible hands.',
      guideText3_3: 'A completely filled cell means the same action in position and out of position after a raise from an opponent.',
      guideText3_4: 'The half-filled cell indicates that the action is different in position and out of position. The left side of the cell shows our action when we are in position(IP), while the right side of the cell shows our action when we are out of position(OOP).',
      guideText3_5: 'Hands that are initially folded.',
      guideText3_6: 'Double suited hands with two bad suits.',
      guideText3_7: 'Double suited hands with two good suits.',
      guideText3_8: 'Colored legend.',

      guideTitle4: 'IV. Starting single suited hand screen.',
      guideText4_1: 'Blue color indicates a single suited hand',

      guideTitle5: 'V. The start screen for rainbow or mono hands (A hand in which all cards are of different suits or of one).',
      guideText5_1: 'Switch for displaying rainbow hands.',
      guideText5_2: 'Switch for displaying mono hands.',

      guideTitle6: 'VI. The screen for the paired double suited hands.',
      guideText6_1: 'The red color of the hand indicates double suit  and the highest pair in hand.',

      guideTitle7: 'VII. The screen for the paired single suited hand.',
      guideText7_1: 'A blue hand indicates single suited suitability and the highest pair in hand.',

      guideTitle8: 'VIII. The starting screen for paired rainbow hands (Hands in which all cards are of different suits).',
      guideText8_1: 'The dark grey color shows a rainbow hand. And the highest pair in hand.',

      guideTitle9: 'Why sometimes Training and Preflop don\'t match?',
      guideText9_1: `
      - Single suited and Double suited hands have multiple suit arrangements in hand.
      <br><br>
      Training shows exactly all the variations of these hands while Preflop has only one cell to display them.
      We have selected the best hands for Preflop that have either a higher EV or higher action rate from these categories to be displayed in one cell.
      It was done so the whole Preflop could reflect the general picture of the game in which the chance of overplaying your hand would be minimized.
      <br><br>
      - Situations against 3bet in Training are shown accurately when specific positions are selected.
      <br><br>
      In Preflop, due to the presence of only one cell for display, the tightest reactions to the 3bet were chosen, where there was a choice. Namely:`,
      guideTitle11: 'To display results from Challenge:',
      guideText11: `
      <br>
      1. Click Challenge (Saving Results)
      <br><br>
      2. Play at least 100 hands for the desired position and filters in one session without refreshing the page, resetting or logging out
      <br><br>
      3. After 100 hands, click New Hand to save results and continue playing, or Stop to finish and save the results
      <br><br>
      4. Average and Best include only complete 100-hand batches. Stopping keeps completed batches saved; an incomplete batch is not included in results
      <br><br>
      5. In Challenge, hands answered incorrectly are not repeated for correction
      `,
      guideText9_3bet_tight_reactions_1: 'OOP',
      guideText9_3bet_tight_reactions_2: 'EP vs MP 3bet',
      guideText9_3bet_tight_reactions_3: 'MP vs CO 3bet',
      guideText9_3bet_tight_reactions_4: 'IP',
      guideText9_3bet_tight_reactions_5: 'EP vs SB 3bet',
      guideText9_3bet_tight_reactions_6: 'MP vs SB 3bet',
      guideText9_3bet_tight_reactions_7: 'CO vs SB 3bet',
      guideText9_3bet_tight_reactions_8: 'BU vs SB 3bet',
      guideText9_2: '- The tightest reactions against the squeeze in Preflop were also chosen.',
      guideText9_squeeze_tight_reactions_2: 'OOP',
      guideText9_squeeze_tight_reactions_3: 'EP vs sqz - MP call + CO sqz',
      guideText9_squeeze_tight_reactions_4: 'IP',
      guideText9_squeeze_tight_reactions_5: 'EP vs sqz - MP call + SB sqz',
      guideText9_squeeze_tight_reactions_6: 'MP vs sqz - CO call + SB sqz',
      guideText9_squeeze_tight_reactions_7: 'CO vs sqz - BU call + SB sqz',
      guideText9_3: 'In future updates, it is planned to add the ability to see all solutions in Preflop.',
      guideTitle10: 'Training',
      guideText10_1: `
      - Some solutions show the EV of all actions, and some do not.
      The absence of EV in one of the solutions is seen if the solver's solution weight is equal to 0%.
      If the weight of a possible solution is even slightly higher than 0%, then they are all shown in Training.
      <br><br>
      - Situation SB limp vs BB raise. The weight (% opportunity) with which the limp was made is shown in brackets.
      `,

      trainingFaqTitle: 'Training',
      trainingFaqText1: 'Smart mode',
      trainingFaqText1_1: 'With smart mode enabled:',
      trainingFaqText1_2: '1. Absolutely unplayable and understandable hands have been removed',
      trainingFaqText1_3: '2. Hands in which a mistake was made are repeated (up 2 correct answers)',
      trainingFaqText2: 'Fast Mode',
      trainingFaqText2_1: 'With Fast mode enabled after the right answer the new hand stars immediately ',
      trainingFaqText3: 'Challenge (Saving Results)',
      trainingFaqText3_1: '1. Click Challenge (Saving Results)',
      trainingFaqText3_2: '2. Play at least 100 hands for the desired position and filters in one session without refreshing the page, resetting or logging out',
      trainingFaqText3_3: '3. After 100 hands, click New Hand to save results and continue playing, or Stop to finish and save the results',
      trainingFaqText3_4: '4. Average and Best include only complete 100-hand batches. Stopping keeps completed batches saved; an incomplete batch is not included in results',
      trainingFaqText3_5: '5. In Challenge, hands answered incorrectly are not repeated for correction',
      trainingFaqText4: 'Difficulty level',
      trainingFaqText5: 'Game selection',
      trainingFaqText6: 'Limit selection',
      trainingFaqText6_1: 'GG Low rake pl 50 - 200 (5%, 2bb)',
      trainingFaqText6_2: 'GG High rake pl 500 - 2000 (5%, 1.5bb)',
      trainingFaqText6_3: 'Low - rake pl 50 on Poker Stars (5%, 4bb)',
      trainingFaqText6_4: 'Med - rake pl 200 on Poker Stars (5%, 1.375bb)',
      trainingFaqText6_5: 'Med+ - rake pl 500 on Poker Stars (5%, 0.6bb)',
      trainingFaqText6_6: 'High - rake pl 5000 on Poker Stars (4.5%, 0.06bb)',
      trainingFaqText6_7: 'MTT POT - Tournament situation by Chip EV. NO rake. Pot bet all preflop options.',
      trainingFaqText6_8: 'MTT 2.25 — Tournament situation by Chip EV. NO rake. 2,25bb openraise.',
      trainingFaqText6_9: 'MTT ANTE POT Tournament situation by Chip EV. NO rake. Pot bet all preflop options. Ante 0.8',
      trainingFaqText6_10: 'MTT ANTE 2.5 Tournament situation by Chip EV. NO rake. 2,5bb openraise. Ante 0.8',
      trainingFaqText6_11: 'HU - rake (5%, 1bb)',
      trainingFaqText6_12: 'Buckets: 30,30,30',
      trainingFaqText6_13: 'Perfect, Large, Large',
      trainingFaqText6_14: 'I/N from 50',
      trainingFaqText7: 'Starting stack seleciton',
      trainingFaqText7_1: 'PS (6max):',
      trainingFaqText7_2: 'GG (6max):',
      trainingFaqText7_3: 'MTT POT:',
      trainingFaqText7_4: 'MTT 2.25:',
      trainingFaqText7_5: 'MTT ANTE POT:',
      trainingFaqText7_6: 'MTT ANTE 2.5:',
      trainingFaqText7_7: 'HU:',
      trainingFaqText8: 'Situation selection',
      trainingFaqText9: 'Position selection',
      trainingFaqText10: 'Hand type selection (filter)',
      trainingFaqText11: 'By pressing you can change and fix back of cards',
      trainingFaqText12: 'Overall frequency for selected position',
      trainingFaqText13: 'EV bb/hand ',
      trainingFaqText14: 'Indicator of correctness',
      trainingFaqText15: 'By pressing you can change and fix card style',
      trainingFaqText16: 'Answer',
      trainingFaqText17: 'Action selection',
      trainingFaqText18: 'Overall range of specific hand type',
      trainingFaqText19: 'Hand and answers counter',
      trainingFaqText20: 'Insert hand ',
      trainingFaqText21: 'Hand type selection (specific hand)',
      trainingFaqText22: 'Action frequency of a hand, or hand’s place in an overall range',
      trainingFaqText23: 'Overall action frequency for selected hand',
      trainingFaqText24: 'Hands list by actions (from the best to the worst)',

      videoTitle1: 'Intro',
      videoTitle2: 'PREFLOP software tutorial',
      videoTitle3: 'Training software tutorial.',

      videoText1: 'In this video we will introduce the main sections of the omahapro.com',
      videoText2: 'This video is about software products where you can find PLO GTO PREFLOP ranges visualization',
      videoText3: 'This video is about Training software where you can practice in PLO GTO preflop',

      plo5guideText1_1: 'Game Selection.',
      plo5guideText1_2: 'DELETE',
      plo5guideText1_3: 'Limit Selection.',
      plo5guideText1_3_6MAX: '6MAX:',
      plo5guideText1_3_6MAX_LOW: 'Low - 5%, 3bb cap',
      plo5guideText1_3_6MAX_HIGH: 'High - 5%, 1bb cap',
      plo5guideText1_3_6MAX_ANTE_POT: 'Ante pot - 5%, 2.5bb cap',
      plo5guideText1_3_6MAX_ANTE_35: 'Ante 3.5 - 5%, 2.5bb cap',
      plo5guideText1_3_HU: 'HU:',
      plo5guideText1_3_HU_LOW: 'Low - 5%, 1.5bb cap',
      plo5guideText1_3_HU_MED: 'Med - 5%, 0.5bb cap',
      plo5guideText1_3_HU_HIGH: 'Low - 5%, 0.125bb cap',
      plo5guideText1_4: 'Stack Selection.',
      plo5guideText1_4_6MAX_LOW: '6MAX LOW:',
      plo5guideText1_4_6MAX_HIGH: '6MAX HIGH:',
      plo5guideText1_4_6MAX_ANTE_POT: 'ANTE POT:',
      plo5guideText1_4_6MAX_ANTE_35: 'ANTE 3.5:',
      plo5guideText1_4_6HU: 'HU:',
      plo5guideText1_5: 'Navigation of steps and possibility to go back a step.',
      plo5guideText1_6: 'Opens another Plo Preflop to compare.',
      plo5guideText1_7: 'Our position.',
      plo5guideText1_8: 'Our position.',
      plo5guideText1_9: 'Multiway situations.',
      plo5guideText1_10: 'Situations when we limp (only in situation SB vs BB), fold or Raise first in.',
      plo5guideText1_10sub: 'BB - situation when everyone folded before SB, then SB limped and now we have to choose whether we check or raise on BB.',
      plo5guideText1_11: 'Situations when somebody raised before us and we have to decide – fold, call or raise.',
      plo5guideText1_12: 'Easy RFI - When turned on, hands are removed from the bottom of the opening (EV below 0.05 on the effectiveness of the action). This feature will be very useful for beginners, as it will remove problematic hands from the opening.',
      plo5guideText1_12_5: 'Smart range - cell gets colored depending on the percentage of folds in this type of hand.',
      plo5guideText1_13: 'On hover, the percentage of actions for each position is displayed.',
      plo5guideTitle2: 'II. SCREEN OF STARTING POSITIONS',
      plo5guideText2_1: 'Displays the selected position',
      plo5guideText2_2: 'Choosing the two highest cards in a hand if the hand does not contain a pair.',
      plo5guideText2_3: 'The presence of 2+ cards of the same suit (All cards that are not double suited fall into this category in 5 card Omaha)',
      plo5guideText2_4: 'Having two cards of the same suit and 2 or 3 cards of the other suit in the hand.',
      plo5guideText2_5: 'Having at least one pair. Blue color stands for single suited hands while red stands for double suited hands.',
      plo5guideText2_6: 'Hands that are initially folded in this position.',
      plo5guideText2_7: 'Impossible starting hands.',
      plo5guideTitle3: 'III. FIRST SCREEN OF DOUBLE SUITED HANDS',
      plo5guideText3_1: 'The red color indicates double suit',
      plo5guideText3_2: 'Impossible hands',
      plo5guideText3_3: 'Good Suited means that there are only 2 cards of each suit, while the fifth card is of the completely different suit.',
      plo5guideText3_4: 'Bad suited means there are 3 cards of one suit and 2 cards of the other suit.',
      plo5guideText3_5: 'Picking the other 2 highest cards.',
      plo5guideText3_6: 'Hands that are initially folded',
      plo5guideTitle4: 'IV. SECOND SCREEN OF DOUBLE SUITED HANDS',
      plo5guideText4_1: 'Impossible hands',
      plo5guideText4_2: 'A completely filled cell means the same action in position and out of position after a raise from an opponent.',
      plo5guideText4_3: 'The half-filled cell indicates that the action is different in position and out of position. The left side of the cell shows our action when we are in position(IP), while the right side of the cell shows our action when we are out of position(OOP)',
      plo5guideText4_4: 'Hands that are initially folded',
      plo5guideText4_5: 'If good suited card was chosen before, good good means that the highest card is in the suit, but if bad suited card was chosen in the first screen, bad good means that the highest card is in the suit with 2 cards.',
      plo5guideText4_6: 'If good suited card was chosen before, good bad means that the highest card is not in the suit, but if bad suited card was chosen in the first screen, bad bad means that the highest card is not in the suit with 2 cards( If the highest card is in the suit with 3 cards it will still be considered bad bad in the second screen).',
      plo5guideText4_7: 'Colored legend',
      plo5guideTitle5: 'V. FIRST SCREEN OF SINGLE SUITED HANDS',
      plo5guideText5_1: 'The blue color indicates single suit',
      plo5guideText5_2: 'Impossible hands',
      plo5guideText5_3: 'Good Suited means that the highest card is in the suit',
      plo5guideText5_4: 'Bad Suited means that the highest card is not in the suit',
      plo5guideText5_5: 'Picking the other 2 highest cards',
      plo5guideText5_6: 'Hands that are initially folded',
      plo5guideTitle6: 'VI. SECOND SCREEN OF SINGLE SUITED HANDS',
      plo5guideText6_1: 'good good or bad good means that the card has only 2 cards of that suit',
      plo5guideText6_2: 'good bad or bad bad means that the card has more than 2 cards of that suit ( If the card has 4 cards of the same suit it is still considered bad suited)',
      plo5guideTitle7: 'VII. SCREEN OF SINGLE SUITED MONO HANDS',
      plo5guideText7_1: 'Switch for displaying mono hands',
      plo5guideTitle8: 'VIII. FIRST SCREEN OF PAIRED DOUBLE SUITED HANDS',
      plo5guideText8_1: 'The red color indicates double suit, also the cell shows the highest pair in the hand',
      plo5guideText8_2: 'Picking the other 2 highest cards in the hand',
      plo5guideText8_3: 'Picking the other highest pair in the hand.',
      plo5guideTitle9: 'IX. SECOND SCREEN OF PAIRED DOUBLE SUITED HANDS',
      plo5guideText9_1: 'This cell shows the highest pair in the hand + second highest pair in the hand or two highest cards in the hand.',
      plo5guideTitle10: 'X. FIRST SCREEN OF PAIRED SINGLE SUITED HANDS',
      plo5guideText10_1: 'The blue color indicates single suit, also the cell shows the highest pair in the hand',
      plo5guideTitle11: 'XI. SECOND SCREEN OF PAIRED SINGLE SUITED HANDS',
      plo5guideText11_1: 'This cell shows the highest pair in the hand + second highest pair in the hand or two highest cards in the hand.',
      plo5guideText11_1sub: '!Note that paired single suited hands cannot be mono!',

      ...firstArticle.en,
      ...secondArticle.en,
      ...landing.en,
      ...header.en,
    },
  },
  ru: {
    translations: {
      challengeLabel: 'Challenge',
      savingResultsLabel: '(Saving Results)',
      challengeSaveHint: 'Чтобы сохранить результаты, включите Challenge.',
      challengeSaveHelp: 'В результаты входят только полные серии из 100 рук для каждой позиции и набора фильтров.',
      challengeSaveHelpStop: 'Нажмите Stop, чтобы завершить сессию. Неполная серия не учитывается в результатах; завершённые серии остаются сохранёнными.',
      stopLabel: 'Stop',
      savingResultsStatus: 'Сохранение результатов…',
      resultsSaveError: 'Не удалось сохранить результаты. Нажмите Stop ещё раз.',
      retrySaveLabel: 'Retry save',
      resultsFaqLabel: 'Results FAQ',
      averageLastMonthLabel: 'Average last month',
      guideTitle1: 'I. Стартовый экран',
      guideText1_1: 'Выбор типа игры.',
      guideText1_2: 'Выбор лимита.',
      guideText1_Low: 'GG Low рейк pl 50 - 200 (5%, 2bb)',
      guideText1_Mid: 'GG High рейк pl 500 - 2000 (5%, 1.5bb)',
      guideText1_High: 'Low — рейк pl 50 на Poker Stars (5%, 4bb)',
      guideText1_MTT: 'Med — рейк pl 200 на Poker Stars (5%, 1.375bb)',
      guideText1_MTT_PLUS: 'Med+ - рейк pl 500 на Poker Stars (5%, 0.6bb)',
      guideText1_MTT_225: 'High — рейк pl 5000 на Poker Stars (4.5%, 0.06bb)',
      guideText1_HU: 'MTT POT — Турнирные ситуации по Chip EV. Отсутствие рейка. Pot bet openraise.',
      guideText1_HU1: 'MTT 2.25 — Турнирные ситуации по Chip EV. Отсутствие рейка. 2,25bb openraise.',
      guideText1_HU2: 'MTT ANTE POT Турнирные ситуации по Chip EV. Отсутствие рейка. Pot bet all preflop options. Ante 0.8',
      guideText1_HU3: 'MTT ANTE 2.5 Турнирные ситуации по Chip EV. Отсутствие рейка. 2,5bb open raise. Ante 0.8',
      guideText1_HU4: 'HU - рейк (5%, 1bb)',
      guideText1_Buckets: 'Buckets: 30,30,30',
      guideText1_Pll: 'Perfect, Large, Large',
      guideText1_In: 'I/N from 50 ',
      guideText1_3: 'Выбор эффективного стартового размера стека.',
      guideText1_cash_game: 'PS (6max):',
      guideText1_mtt: 'GG (6max):',
      guideText1_mtt_225: 'MTT POT:',
      guideText1_hu: 'MTT 2.25:',
      guideText1_hu1: 'MTT ANTE POT:',
      guideText1_hu2: 'MTT ANTE 2.5:',
      guideText1_hu3: 'HU:',
      guideText1_4: 'Навигация пути где вы сейчас находитесь. Кликабельно, можно вернуться на шаг или несколько назад.',
      guideText1_5: 'Возможность открыть еще в одном окне еще один Plo Preflop для сравнения двух разных ситуаций.',
      guideText1_6: 'Наши позициии для верхней правой части Plo Preflop.',
      guideText1_7: 'Наши позиции для левой нижней части Plo Preflop.',
      guideText1_8: 'Мультивей ситуации для левой нижней части Plo Preflop.',
      guideText1_9: 'Ситуации, когда мы первыми фолдим, лимпим (только для ситуации SB vs BB) или рейзим на префлопе.',
      guideText1_9_BB_situation: 'BB - ситуация, когда все до SB сыграли фолд, SB делает лимп и у нас выбор на BB между чеком и рейзом.',
      guideText1_10: 'Ситуации, когда до нас был рейз и у нас решение фолд, колл или рейз.',
      guideText1_11: 'Easy RFI - при включении убираются руки из низа диапазона (EV ниже 0,05 на текущее действие). Данная функция будет очень полезна для новичков, так как уберет из розыгрыша проблемные руки.',
      guideText1_12: 'Smart range - ячейка окрашивается в зависимости от процента фолдов в данном типе рук.',
      guideText1_13: 'При наведении отображаются проценты действий для каждой позиции.',

      guideTitle2: 'II. Экран стартовой позиции',
      guideText2_1: 'Отображение выбранной позиции.',
      guideText2_2: 'Определение двух старших карт в руке при пересечении. Если стартовая рука не содержит в себе пару.',
      guideText2_3: 'Наличие от 2 до 3 карт одной масти (одномастная) в стартовой руке.',
      guideText2_4: 'Наличие двух карт одной масти и еще двух другой (двумастная рука) в стартовой руке.',
      guideText2_5: 'Если в стартовой руке есть хотя бы одна пара. Синим - если рука одномастная. Красным - если рука двумастная.',
      guideText2_6: 'Стартовый номинал рук которые играются фолдом с этой позиции.',
      guideText2_7: 'Невозможные стартовые руки.',

      guideTitle3: 'III. Экран стартовой двумастной руки.',
      guideText3_1: 'Красный цвет руки показывает двухмастность.',
      guideText3_2: 'Невозможные руки.',
      guideText3_3: 'Полностью закрашенная ячейка означает одинаковую игру находясь в позиции и без позиции после рейза от оппонента.',
      guideText3_4: 'Наполовину закрашенная ячейка означает. Левая сторона ячейки - игра в позиции после рейза оппонента. Правая сторона ячейки - игра без позиции после рейза от оппонента.',
      guideText3_5: 'Руки которые изначально играются фолд.',
      guideText3_6: 'Двухмастные руки с двумя плохими мастями.',
      guideText3_7: 'Двухмастные руки с двумя хорошими мастями.',
      guideText3_8: 'Объяснение наших действий путем цветовых меток.',

      guideTitle4: 'IV. Экран стартовой одномастной руки.',
      guideText4_1: 'Синий цвет руки показывает одномастность.',

      guideTitle5: 'V. Экран стартовой безмастной (rainbow) или моно руки. Рука в которой все карты разных мастей или одной.',
      guideText5_1: 'Переключатель для отображения безмастной руки.',
      guideText5_2: 'Переключатель для отображения моно руки.',

      guideTitle6: 'VI. Экран стартовой парной двухмастной руки.',
      guideText6_1: 'Красный цвет руки показывает двухмастность. И пару которая является старшей в руке.',

      guideTitle7: 'VII. Экран стартовой парной одномастной руки.',
      guideText7_1: 'Синий цвет руки показывает одномастность. И пару которая является старшей в руке.',

      guideTitle8: 'VIII. Экран стартовой парной безмастной (rainbow) руки. Рука в которой все карты разных мастей.',
      guideText8_1: 'Темный цвет руки показывает безмастность. И пару которая является старшей в руке.',

      guideTitle9: 'Почему иногда Training и Preflop не совпадают?',
      guideText9_1: `
      - Single suited и Double suited руки имеют несколько вариантов расстановки мастей в руке.
      <br><br>
      Training показывает точно все варианты этих рук, а Preflop имеет для отображения только одну ячейку. Мы выбрали для Preflop
      лучшие руки, которые имеют или большее EV или большую частоту действий из этих категорий для отображения в одной ячейке.
      Для того, чтобы в целом Preflop отображал общую картину игры при которой шанс переиграть свою руку будет минимизирован.
      <br><br>
      - Ситуации против трибета в Training показываются точно при выборе конкретных позиций.
      <br><br>
      В Preflop из-за наличия всего одной ячейки для отображения были выбраны самые тайтовые реакции на трибет, где был выбор. А именно:`,
      guideTitle11: 'Для отображения результатов из Challenge:',
      guideText11: `
      <br>
      1. Включите Challenge (Saving Results)
      <br><br>
      2. Сыграйте не менее 100 рук для нужной позиции и фильтров за одну сессию, не обновляя страницу, не сбрасывая сессию и не выходя из аккаунта
      <br><br>
      3. После 100 рук нажмите New Hand, чтобы сохранить результаты и продолжить игру, или Stop, чтобы завершить сессию и сохранить результаты
      <br><br>
      4. Средние и лучшие результаты учитывают только полные серии из 100 рук. При остановке завершённые серии остаются сохранёнными; неполная серия не учитывается в результатах
      <br><br>
      5. В Challenge руки с ошибками не повторяются для исправления
      `,
      guideText9_3bet_tight_reactions_1: 'OOP',
      guideText9_3bet_tight_reactions_2: 'EP vs MP 3bet',
      guideText9_3bet_tight_reactions_3: 'MP vs CO 3bet',
      guideText9_3bet_tight_reactions_4: 'IP',
      guideText9_3bet_tight_reactions_5: 'EP vs SB 3bet',
      guideText9_3bet_tight_reactions_6: 'MP vs SB 3bet',
      guideText9_3bet_tight_reactions_7: 'CO vs SB 3bet',
      guideText9_3bet_tight_reactions_8: 'BU vs SB 3bet',
      guideText9_2: '- Так же были выбраны самые тайтовые реакции против сквиза в Preflop.',
      guideText9_squeeze_tight_reactions_2: 'OOP',
      guideText9_squeeze_tight_reactions_3: 'EP vs sqz - MP call + CO sqz',
      guideText9_squeeze_tight_reactions_4: 'IP',
      guideText9_squeeze_tight_reactions_5: 'EP vs sqz - MP call + SB sqz',
      guideText9_squeeze_tight_reactions_6: 'MP vs sqz - CO call + SB sqz',
      guideText9_squeeze_tight_reactions_7: 'CO vs sqz - BU call + SB sqz',
      guideText9_3: 'В дальнейших апдейтах планируется добавить возможность в Preflop увидеть все решения.',

      guideTitle10: 'Training',
      guideText10_1: `
      - В некоторых решениях показывается EV всех действий, а в некоторых нет. Отсутствие EV одного из решений
      происходит если солвер вес решения указывает ровно 0%. Если вес возможного решения хоть чуть выше 0%,
      то они показываются все в Training.
      <br><br>
      - Ситуация SB limp vs BB raise. В скобках показывается вес ( % возможность) с которым был сделан лимп.
      `,

      trainingFaqTitle: 'Training',
      trainingFaqText1: 'Smart mode',
      trainingFaqText1_1: 'При включенном Smart Mode:',
      trainingFaqText1_2: '1. Убраны абсолютно неиграбельные и всем понятные руки.',
      trainingFaqText1_3: '2. Руки в которых была допущена ошибка повторяются ( до 2х правильных ответов)',
      trainingFaqText2: 'Fast Mode',
      trainingFaqText2_1: 'При включенном Fast Mode после правильного ответа сразу следует новая рука',
      trainingFaqText3: 'Challenge (Saving Results)',
      trainingFaqText3_1: '1. Включите Challenge (Saving Results)',
      trainingFaqText3_2: '2. Сыграйте не менее 100 рук для нужной позиции и фильтров за одну сессию, не обновляя страницу, не сбрасывая сессию и не выходя из аккаунта',
      trainingFaqText3_3: '3. После 100 рук нажмите New Hand, чтобы сохранить результаты и продолжить игру, или Stop, чтобы завершить сессию и сохранить результаты',
      trainingFaqText3_4: '4. Средние и лучшие результаты учитывают только полные серии из 100 рук. При остановке завершённые серии остаются сохранёнными; неполная серия не учитывается в результатах',
      trainingFaqText3_5: '5. В Challenge руки с ошибками не повторяются для исправления',
      trainingFaqText4: 'Уровень сложности тренировки',
      trainingFaqText5: 'Выбор типа игры',
      trainingFaqText6: 'Выбор лимита',
      trainingFaqText6_1: 'GG Low рейк pl 50 - 200 (5%, 2bb)',
      trainingFaqText6_2: 'GG High рейк pl 500 - 2000 (5%, 1.5bb)',
      trainingFaqText6_3: 'Low — рейк pl 50 на Poker Stars (5%, 4bb)',
      trainingFaqText6_4: 'Med — рейк pl 200 на Poker Stars (5%, 1.375bb)',
      trainingFaqText6_5: 'Med+ - рейк pl 500 на Poker Stars (5%, 0.6bb)',
      trainingFaqText6_6: 'High — рейк pl 5000 на Poker Stars (4.5%, 0.06bb)',
      trainingFaqText6_7: 'MTT POT — Турнирные ситуации по Chip EV. Отсутствие рейка. Pot bet openraise.',
      trainingFaqText6_8: 'MTT 2.25 — Турнирные ситуации по Chip EV. Отсутствие рейка. 2,25bb openraise.',
      trainingFaqText6_9: 'MTT ANTE POT Турнирные ситуации по Chip EV. Отсутствие рейка. Pot bet all preflop options. Ante 0.8',
      trainingFaqText6_10: 'MTT ANTE 2.5 Турнирные ситуации по Chip EV. Отсутствие рейка. 2,5bb open raise. Ante 0.8',
      trainingFaqText6_11: 'HU - рейк (5%, 1bb)',
      trainingFaqText6_12: 'Buckets: 30,30,30',
      trainingFaqText6_13: 'Perfect, Large, Large',
      trainingFaqText6_14: 'I/N from 50',
      trainingFaqText7: 'Выбор эффективного стартового размера стека',
      trainingFaqText7_1: 'PS (6max):',
      trainingFaqText7_2: 'GG (6max):',
      trainingFaqText7_3: 'MTT POT:',
      trainingFaqText7_4: 'MTT 2.25:',
      trainingFaqText7_5: 'MTT ANTE POT:',
      trainingFaqText7_6: 'MTT ANTE 2.5:',
      trainingFaqText7_7: 'HU:',
      trainingFaqText8: 'Выбор ситуации',
      trainingFaqText9: 'Выбор позиции',
      trainingFaqText10: 'Выбор типа руки',
      trainingFaqText11: 'При нажатии меняется и фиксируется цвет обложки карт',
      trainingFaqText12: 'Общая частота действий для выбранной позиции',
      trainingFaqText13: 'EV действий bb/hand ',
      trainingFaqText14: 'Индикатор правильности действия',
      trainingFaqText15: 'При нажатии меняется и фиксируется стиль карт',
      trainingFaqText16: 'Ответ',
      trainingFaqText17: 'Выбор действий',
      trainingFaqText18: 'Возможность посмотреть общий диапазон типа руки по двум основным картам',
      trainingFaqText19: 'Счетчик рук и ответов',
      trainingFaqText20: 'Окно для ввода руки',
      trainingFaqText21: 'Выбор типа конкретной руки',
      trainingFaqText22: 'Частота действия руки, либо определения положения руки в диапазоне',
      trainingFaqText23: 'Общая частота действий для выбранной руки ',
      trainingFaqText24: 'Список по действиям всех вариаций выбранной руки (от лучших к худшим)',

      videoTitle1: 'Описание основных разделов сайта',
      videoTitle2: 'Руководство по PREFLOP разделу',
      videoTitle3: 'Руководство по разделу Training',

      videoText1: 'В этом видео мы расскажем об основных разделах на сайте omahapro.com',
      videoText2: 'В этом видео мы расскажем вам как пользоваться разделом PREFLOP в котором визуализированы PLO GTO префлоп диапазоны.',
      videoText3: 'Это видео посвящено обучающему разделу Training, с помощью которого вы можете практиковаться в PLO GTO на префлопе.',

      plo5guideText1_1: 'Выбор типа игры.',
      plo5guideText1_2: 'DELETE',
      plo5guideText1_3: 'Выбор лимита.',
      plo5guideText1_3_6MAX: '6MAX:',
      plo5guideText1_3_6MAX_LOW: 'Low - 5%, 3bb cap',
      plo5guideText1_3_6MAX_HIGH: 'High - 5%, 1bb cap',
      plo5guideText1_3_6MAX_ANTE_POT: 'Ante pot - 5%, 2.5bb cap',
      plo5guideText1_3_6MAX_ANTE_35: 'Ante 3.5 - 5%, 2.5bb cap',
      plo5guideText1_3_HU: 'HU:',
      plo5guideText1_3_HU_LOW: 'Low - 5%, 1.5bb cap',
      plo5guideText1_3_HU_MED: 'Med - 5%, 0.5bb cap',
      plo5guideText1_3_HU_HIGH: 'Low - 5%, 0.125bb cap',
      plo5guideText1_4: 'Выбор эффективного стартового размера стека.',
      plo5guideText1_4_6MAX_LOW: '6MAX LOW:',
      plo5guideText1_4_6MAX_HIGH: '6MAX HIGH:',
      plo5guideText1_4_6MAX_ANTE_POT: 'ANTE POT:',
      plo5guideText1_4_6MAX_ANTE_35: 'ANTE 3.5:',
      plo5guideText1_4_6HU: 'HU:',
      plo5guideText1_5: 'Навигация пути где вы сейчас находитесь. Кликабельно, можно вернуться на шаг или несколько назад.',
      plo5guideText1_6: 'Возможность открыть еще в одном окне еще один Plo Preflop для сравнения двух разных ситуаций.',
      plo5guideText1_7: 'Наша позиция.',
      plo5guideText1_8: 'Наша позиция.',
      plo5guideText1_9: 'Мультивей ситуации для левой нижней части Plo Preflop.',
      plo5guideText1_10: 'Ситуации, когда мы первыми фолдим, лимпим(только для ситуации SB vs BB) или рейзим на префлопе.',
      plo5guideText1_10sub: 'BB - ситуация, когда все до SB сыграли фолд, SB делает лимп и у нас выбор на BB между чеком и рейзом.',
      plo5guideText1_11: 'Ситуации, когда до нас был рейз и у нас решение фолд, колл или рейз.',
      plo5guideText1_12: 'Easy RFI - при включении убираются руки из низа диапазона (EV ниже 0,05 на текущее действие). Данная функция будет очень полезна для новичков, так как уберет из розыгрыша проблемные руки.',
      plo5guideText1_12_5: 'Smart range - ячейка окрашивается в зависимости от процента фолдов в данном типе рук.',
      plo5guideText1_13: 'При наведении отображается процент действий для каждой позиции.',
      plo5guideTitle2: 'II. ЭКРАН СТАРТОВОЙ ПОЗИЦИИ',
      plo5guideText2_1: 'Отображение выбранной позиции.',
      plo5guideText2_2: 'Выбор двух старших карт в руке, если в руке нет пары.',
      plo5guideText2_3: 'Наличие 2+ карт одной масти (Все руки, не являющиеся двухмастными, попадают в эту категорию в 5-карточной Омахе)',
      plo5guideText2_4: 'Наличие в руке двух карт одной масти и 2 или 3 карт другой масти.',
      plo5guideText2_5: 'Наличие хотя бы одной пары. Синий цвет обозначает руки с одной мастью, а красный — руки с двумя мастями.',
      plo5guideText2_6: 'Стартовый номинал рук которые играются фолдом с этой позиции.',
      plo5guideText2_7: 'Невозможные стартовые руки.',
      plo5guideTitle3: 'III. ПЕРВЫЙ ЭКРАН ДЛЯ ДВУХМАСТНЫХ РУК',
      plo5guideText3_1: 'Красный цвет указывает на двухмастность',
      plo5guideText3_2: 'Невозможные руки',
      plo5guideText3_3: 'Good Suited означает, что есть по 2 карты каждой масти, а пятая карта совсем другой масти.',
      plo5guideText3_4: 'Bad Suited означает, что есть 3 карты одной масти и 2 карты другой масти.',
      plo5guideText3_5: 'Выбор двух других старших карт.',
      plo5guideText3_6: 'Стартовый номинал рук которые играются фолдом с этой позиции.',
      plo5guideTitle4: 'IV. ВТОРОЙ ЭКРАН ДЛЯ ДВУХМАСТНЫХ РУК',
      plo5guideText4_1: 'Невозможные руки',
      plo5guideText4_2: 'Полностью закрашенная ячейка означает одинаковую игру находясь в позиции и без позиции после рейза от оппонента.',
      plo5guideText4_3: 'Наполовину заполненная ячейка указывает на то, что действие в позиции и вне позиции отличается. В левой части ячейки показаны наши действия, когда мы находимся в позиции (IP), а в правой части ячейки показаны наши действия, когда мы вне позиции (OOP).',
      plo5guideText4_4: 'Стартовый номинал рук которые играются фолдом с этой позиции.',
      plo5guideText4_5: 'Если ранее была выбрана Good Suited, good good означает, что старшая карта в масть, но если на первом экране была выбрана Bad Suited, bad good означает, что старшая карта находится в масть с двумя картами.',
      plo5guideText4_6: 'Если ранее была выбрана Good Suited, good bad означает, что старшая карта не в масть, но если на первом экране была выбрана Bad Suited, bad bad означает, что старшая карта не в масти с двумя картами (если старшая карта находится в масти с 3 картами, она все равно будет считаться bad bad на втором экране).',
      plo5guideText4_7: 'Объяснение наших действий путем цветовых меток.',
      plo5guideTitle5: 'V. ПЕРВЫЙ ЭКРАН ДЛЯ ОДНОМАСТНЫХ РУК',
      plo5guideText5_1: 'Синий цвет руки показывает одномастность.',
      plo5guideText5_2: 'Невозможные руки',
      plo5guideText5_3: 'Good Suited означает, что старшая карта находится в масть',
      plo5guideText5_4: 'Bad Suited означает, что старшая карта не в масть.',
      plo5guideText5_5: 'Выбор двух других старших карт',
      plo5guideText5_6: 'Стартовый номинал рук которые играются фолдом с этой позиции.',
      plo5guideTitle6: 'VI. ВТОРОЙ ЭКРАН ДЛЯ ОДНОМАСТНЫХ РУК',
      plo5guideText6_1: 'good good или bad good означает, что в руке есть только 2 карты этой масти.',
      plo5guideText6_2: 'good bad или bad bad означает, что карта содержит более 2 карт одной масти (если в руке 4 карты одной масти, она по-прежнему считается плохой мастью)',
      plo5guideTitle7: 'VII. ЭКРАН ДЛЯ ОДНОМАСТНЫХ МОНО РУК',
      plo5guideText7_1: 'Переключатель для отображения моно рук',
      plo5guideTitle8: 'VIII. ПЕРВЫЙ ЭКРАН ДЛЯ ПАРНЫХ ДВУХМАСТНЫХ РУК',
      plo5guideText8_1: 'Красный цвет показывает двухмастность, также в ячейке указана старшая пара в руке',
      plo5guideText8_2: 'Выбор двух других старших карт в руке',
      plo5guideText8_3: 'Выбор другой старшей пары в раздаче.',
      plo5guideTitle9: 'IX. ВТОРОЙ ЭКРАН ДЛЯ ПАРНОЙ ДВУХМАСТНОЙ РУКИ',
      plo5guideText9_1: 'В этой ячейке показана старшая пара в руке + вторая по старшинству пара в руке или две старшие карты в руке.',
      plo5guideTitle10: 'X. ПЕРВЫЙ ЭКРАН ДЛЯ ПАРНОЙ ОДНОМАСТНОЙ РУКИ',
      plo5guideText10_1: 'Синий цвет обозначает одномастность, также в ячейке указана старшая пара в руке',
      plo5guideTitle11: 'XI. ВТОРОЙ ЭКРАН ДЛЯ ПАРНОЙ ОДНОМАСТНОЙ РУКИ',
      plo5guideText11_1: 'В этой ячейке указана старшая пара в руке + вторая по старшинству пара в руке или две старшие карты в руке.',
      plo5guideText11_1sub: '!Обратите внимание, что парные одномастные руки не могут быть моно!',

      ...firstArticle.ru,
      ...secondArticle.ru,
      ...landing.ru,
      ...header.ru,
    },
  },
};
